import { render } from "./OnHoldPhases.vue?vue&type=template&id=1b90091a&scoped=true"
import script from "./OnHoldPhases.vue?vue&type=script&lang=js"
export * from "./OnHoldPhases.vue?vue&type=script&lang=js"

import "./OnHoldPhases.vue?vue&type=style&index=0&id=1b90091a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b90091a"]])

export default __exports__